import defaultIMG from '@/assets/imgs/cards/bg5.png';
import { Icon, Image } from '@/components/generic';
import { temporaryNameCards } from '@/constants';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

type CardTypeProps = {
  value: any;
  hasPendingTransactions?: boolean;
  handlerCardtypeSelect?: (cardType: any) => void;
};
const CardType = ({
  value,
  hasPendingTransactions,
  handlerCardtypeSelect,
}: CardTypeProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        'group relative flex justify-start shrink-0 w-77.5 mr-3 p-3 cursor-pointer last:mr-0 max-lg:mr-6 max-lg:px-0 max-md:w-74',
        hasPendingTransactions && 'cursor-not-allowed',
      )}
      onClick={() => handlerCardtypeSelect && handlerCardtypeSelect(value)}
    >
      {!hasPendingTransactions && (
        <div className='box-hover max-lg:hidden'></div>
      )}
      <div className='relative z-2 shrink-0'>
        <Image
          className='size-16 rounded-xl opacity-100 object-cover'
          src={defaultIMG}
          alt={
            temporaryNameCards[
              (value?.cardTypeId as keyof typeof temporaryNameCards) || 0
            ]?.name || value.cardTypeId
          }
        />
      </div>
      <div className='relative z-2 w-[calc(100%-4rem)] pl-3'>
        <div className='flex items-center mb-1'>
          <div className='grow truncate text-sub-title-1 font-medium'>
            {t('newcard.debit_card')}
          </div>
          <div className='shrink-0 ml-2 label label-green'>{t('newcard.available')}</div>
        </div>
        <div className='text-body-2 text-t-secondary/80'>
          {value?.hasCardHolder
            ? t('newcard.has_card_holder')
            : t('newcard.need_card_holder')}
        </div>
        <div className='flex items-center gap-2 text-sub-title-1'>
          {value?.activeCardCount || 0}
          <Icon className='!size-4 fill-t-primary' name='product' />
        </div>
      </div>
    </div>
  );
};

export default CardType;
